import IsLoading from "components/common/IsLoading";
import Spinners from "components/common/Spinners";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  checkVerificationStatus,
  resendVerificationLink,
  verifyEmail,
} from "store/actions/authSlice";
import { showAlert } from "store/reducers/alertReducer";

// VERIFICATION PAGE AFTER SIGNUP VIA EMAIL
const CheckVerificationStatus = () => {
  // const { search } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const { signUpUser } = useSelector((state) => state.auth);
  const { isLoading } = useSelector((state) => state.auth);

  // const queryParams = new URLSearchParams(search);
  // const userId = queryParams.get("userId");
  const userId = localStorage.getItem("authUserId");

  useEffect(() => {
    console.log("userId", userId);
    if (!userId) {
      console.log("No userId found in state.");
      return;
    }

    // Function to be called every 5 seconds

    const checkVerification = () => {
      // console.log("Inside Check Verification");
      if (!isEmailVerified) {
        // console.log("Inside Check Verification State");
        dispatch(checkVerificationStatus({ userId }))
          .then((action) => {
            const { statusCode, success, message, data } =
              action?.payload || {};
            if (statusCode === 200 && success) {
              const { autoRedirectUrl } = data || {};

              dispatch(showAlert({ text: message, type: "success" }));
              const { hasSubscriptionEntry, selectedPlan } = data || {};
              // if (!hasSubscriptionEntry) {
                window.location.replace(autoRedirectUrl)
                // navigate("/plan-picker");
              // }
              setIsEmailVerified(true);
            }
          })
          .catch((err) => {});
      }
    };

    const intervalId = setInterval(checkVerification, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [signUpUser?._id, dispatch]);

  const handleResendEmail = () => {
    dispatch(resendVerificationLink({ id: userId }))
      .then((action) => {
        const { statusCode, success, message } = action?.payload || {};
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }));
        } else {
          dispatch(showAlert({ text: message, type: "error" }));
        }
      })
      .catch((err) => {});
  };

  return (
    <div className="welcome_pg_bg">
      <div className="container">
        <div className="two_column_pg check_verification_status">
          <div className="container position-relative">
            <IsLoading />
            <div className="tcp_inner">
              <div className="text-center w-100 text_black">
                <p className="">
                  Verification email has been sent. Please check your email to
                  verify your account.
                </p>
                <button
                  className="main_btn mt-4 text-center fs_20"
                  onClick={handleResendEmail}
                  disabled={isLoading}
                >
                  Resend Email
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckVerificationStatus;
